<template>
  <div class="header">
    <h1>Sign inspection agreements</h1>
    <p id="header--instructions" class="instructions">
      Please read and sign the agreements(s) by selecting 'Agree' and typing your full name.
    </p>
    <p v-if="companyPhone || companyEmail" id="header--contact" class="instructions">Questions?
      <span v-if="companyPhone" id="header--contact-phone">
        Call <a class="link" :href="`tel:${companyPhone}`">{{companyPhone}}</a>
      </span>
      <span v-if="companyEmail && companyPhone" id="header--contact-junction"> or</span>
      <span v-if="companyEmail" id="header--contact-email">
        Email <a class="link" :href="`mailto:${companyEmail}`">{{companyEmail}}</a>
      </span>
      .
    </p>
  </div>
</template>

<script>
export default {
  props: {
    companyEmail: {
      type: String,
      default: '',
    },
    companyPhone: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

h1 {
  font-size: 2.5rem;
  margin-bottom: 10px;
  margin-top: 10px;
  text-align: center;
  text-transform: none;
}

.instructions {
  text-align: center;
}

p {
  color: rgba($theme-color-black, 0.6);
  font-size: 1.286rem;
  margin: 0;
  padding: 0;
}

.btn-tertiary {
  text-decoration: none;
}

.link {
  color: $typography-color-link;
  text-decoration: underline;
}

.header {
  border-bottom: none;
  margin-bottom: 60px;
}
</style>
